/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TasksCommentTextarea/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import EditableTextArea from 'DesignSystem/EditableTextArea/react'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TasksCommentTextarea({
  children,
  viewPath = "/DesignSystem/TasksCommentTextarea",
  value,
  onChange,
  disabled,
  maxLength
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<div
  data-testid="TasksCommentTextarea.Vertical"
  data-view-path={viewPath}
 style={{'--pt-1-1cphOO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-2-1cphOO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-3-1cphOO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-4-1cphOO': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--c-5-1cphOO': dtColorsNeutral900}}
 className={`views-block tasks-comment-textarea ${styles.Vertical}`}
>
<EditableTextArea
  viewPath={`${viewPath}/EditableTextArea`}
 value={value}
 onChange={onChange}
 disabled={disabled}
 toolbar={false}
 menubar={false}
 inline={true}
 selector="tasks-comment-textarea"
 autocomplete={false}
 toolbarPersist={false}
 placeholder="Add comment..."
 maxLength={maxLength}
 plaintext={true}
 autoFocus={false}
/>
</div>
{children}
</React.Fragment>)
}